import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import StarIcon from '@material-ui/icons/Star';
import RankIcon from '@material-ui/icons/EmojiEvents';
import ArrowDownIcon from '../../../icons/ArrowDownIcon';
import ArrowUpIcon from '../../../icons/ArrowUpIcon';
import EqualsIcon from '../../../icons/EqualsIcon';
import { kassimBlue, backgroundGrey } from '../../../style/theme';
import { round } from 'lodash';

const ResultIconContainer = styled.div`
    background: #fff;
    border-radius: 50%;
    padding: 2px;
    align-self: center;
`;
const ResultIcon = styled.svg`
    font-size: 0.9rem;
    color: ${({ $color }) => $color};
    display: block;
`;

// const EqualsIcon = styled(PauseIcon)`
//     transform: rotate(90deg);
// `;

const coloring = {
    up: '#08ce04',
    down: 'red',
    equal: backgroundGrey,
    notSet: kassimBlue,
};
function getColoring(trend) {
    if (typeof trend === 'undefined' || trend === null) {
        return coloring.notSet;
    }
    if (trend > 0) return coloring.up;
    if (trend < 0) return coloring.down;
    return coloring.equal;
}
// const ColorSpan = styled.span`
//     color: ${({ $color }) => $color};
// `;
function getResultIcon(trend) {
    if (typeof trend === 'undefined' || trend === null) {
        return null;
    }
    let icon = null;
    if (trend > 0) {
        icon = <ResultIcon as={ArrowUpIcon} $color={coloring.up} />;
    } else if (trend < 0) {
        icon = <ResultIcon as={ArrowDownIcon} $color={coloring.down} />;
    } else {
        icon = <ResultIcon as={EqualsIcon} $color={coloring.equal} />;
    }
    return <ResultIconContainer>{icon}</ResultIconContainer>;
}
const SubScoresWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1 1 120px;
    max-width: 90%;
`;

const SubScoreChip = styled.div`
    /* width: 120px; */
    background: ${backgroundGrey};
    color: #ffffff;
    padding: 0px 8px;
    border-radius: 9999px;
    display: flex;
    gap: 4px;
    justify-content: space-between;
    align-items: center;

    & ${ResultIcon} {
        font-size: 0.8rem;
    }
`;
const SubScoreValue = styled.div`
    flex: 1 1 30px;
    text-align: right;
`;
const SubScoreUnit = styled.div`
    flex: 1 1 30px;
    color: #eee;
    font-size: 90%;
`;

const MainScoreWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1 1 120px;
    max-width: 90%;
`;

const MainContainer = styled.div`
    height: 100%;
    color: ${kassimBlue};
    display: flex;
    gap: 1vw;
    justify-content: space-evenly;
    align-items: center;
    padding: 8px;
    flex-wrap: wrap;
`;

const StyledChip = styled.div`
    font-size: 1.5rem;
    background-color: #ffc107;
    color: #ffffff;
    border-radius: 9999px;
    padding: 4px 8px;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    text-shadow: 0px 0px 2px #00000080;
`;

const ScorePanel = ({ status, smallScreen, className }) => {
    const { t } = useTranslation();

    const { score } = status;
    const { prod, prof, eff, points, position, trend } = score || {};

    if (!score) return null;

    return (
        <MainContainer className={className} $smallScreen={smallScreen}>
            <SubScoresWrapper>
                {/* <SubScoreContainer $color={getColoring(trend?.prod)}>
                    <ColorSpan $color={getColoring(trend?.prod)}>
                        {round(prod, 1)}
                    </ColorSpan>{' '}
                    kg/m&sup2; {getResultIcon(trend?.prod)}
                </SubScoreContainer> */}
                <SubScoreChip>
                    <SubScoreValue>{round(prod, 1)}</SubScoreValue>
                    <SubScoreUnit>kg/m&sup2;</SubScoreUnit>
                    {getResultIcon(trend?.prod)}
                </SubScoreChip>
                <SubScoreChip>
                    <SubScoreValue>{round(prof, 1)}</SubScoreValue>
                    <SubScoreUnit>&euro;/m&sup2;</SubScoreUnit>
                    {getResultIcon(trend?.prof)}
                </SubScoreChip>
                <SubScoreChip>
                    <SubScoreValue>{round(eff, 1)}</SubScoreValue>
                    <SubScoreUnit>kg/MJ</SubScoreUnit>
                    {getResultIcon(trend?.eff)}
                </SubScoreChip>
            </SubScoresWrapper>
            <MainScoreWrapper>
                <StyledChip>
                    <StarIcon />
                    {round(points)}
                    {getResultIcon(trend?.points)}
                </StyledChip>
                <StyledChip>
                    <RankIcon />
                    {position}
                    {getResultIcon(trend?.position)}
                </StyledChip>
            </MainScoreWrapper>
        </MainContainer>
    );
};

export default ScorePanel;
